// Primary 3 Mathematics Data - 小學三年級數學數據
export const p3MathsData = {
  title: '小學三年級數學',
  description: '深入學習數學概念，掌握更複雜的運算技能',
  grade: 'P3',
  year: '小學三年級',
  
  topics: [
    {
      id: 'p3-3n1',
      code: '3N1',
      title: '五位數',
      description: '認識五位數，理解萬位概念',
      objectives: [
        '認識10000-99999的數字',
        '理解萬位、千位、百位、十位、個位',
        '學會讀寫五位數',
        '比較五位數的大小'
      ],
      sampleQuestions: [
        {
          id: 'p3-3n1-q1',
          question: '寫出數字：二萬三千四百五十六',
          answer: '23456',
          solution: '二萬三千四百五十六 = 20000 + 3000 + 400 + 50 + 6 = 23456',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n1-q2',
          question: '讀出數字：56789',
          answer: '五萬六千七百八十九',
          solution: '56789 = 50000 + 6000 + 700 + 80 + 9',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n1-q3',
          question: '比較大小：23456 和 24356',
          answer: '23456 < 24356',
          solution: '比較千位：3 < 4，所以23456 < 24356',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n1-q4',
          question: '在20000到30000之間有多少個數字？',
          answer: '9999個',
          solution: '20000到30000之間的數字是：20001, 20002, ..., 29999，共9999個。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n1-q5',
          question: '寫出比99999大1的數字。',
          answer: '100000',
          solution: '99999 + 1 = 100000\n99999加1後變成100000，這是一個六位數。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3n2',
      code: '3N2',
      title: '加法和減法(四)',
      description: '學習五位數的加減法運算',
      objectives: [
        '學會五位數的加法',
        '學會五位數的減法',
        '理解多位數的進位和退位',
        '解決五位數的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p3-3n2-q1',
          question: '計算：12345 + 67890 = ?',
          answer: '80235',
          solution: '12345 + 67890 = 80235\n個位：5 + 0 = 5\n十位：4 + 9 = 13，寫3進1\n百位：3 + 8 + 1 = 12，寫2進1\n千位：2 + 7 + 1 = 10，寫0進1\n萬位：1 + 6 + 1 = 8',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n2-q2',
          question: '計算：45678 - 23456 = ?',
          answer: '22222',
          solution: '45678 - 23456 = 22222\n各位相減：8-6=2, 7-5=2, 6-4=2, 5-3=2, 4-2=2',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n2-q3',
          question: '小明有34567元，買了一台電腦花了23456元，還剩下多少元？',
          answer: '11111元',
          solution: '34567 - 23456 = 11111\n小明原本有34567元，花了23456元，所以還剩下11111元。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n2-q4',
          question: '計算：12345 + 23456 + 34567 = ?',
          answer: '70368',
          solution: '12345 + 23456 + 34567 = 70368\n先算：12345 + 23456 = 35801\n再算：35801 + 34567 = 70368',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n2-q5',
          question: '小華有56789個糖果，給了小明23456個，又給了小紅12345個，還剩下多少個？',
          answer: '20988個',
          solution: '56789 - 23456 - 12345 = 20988\n先算：56789 - 23456 = 33333\n再算：33333 - 12345 = 20988',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3n3',
      code: '3N3',
      title: '乘法(二)',
      description: '學習多位數的乘法運算',
      objectives: [
        '學會兩位數乘以一位數',
        '學會三位數乘以一位數',
        '理解乘法的進位概念',
        '解決乘法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p3-3n3-q1',
          question: '計算：23 × 4 = ?',
          answer: '92',
          solution: '23 × 4 = 92\n個位：3 × 4 = 12，寫2進1\n十位：2 × 4 + 1 = 9',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n3-q2',
          question: '計算：156 × 7 = ?',
          answer: '1092',
          solution: '156 × 7 = 1092\n個位：6 × 7 = 42，寫2進4\n十位：5 × 7 + 4 = 39，寫9進3\n百位：1 × 7 + 3 = 10',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n3-q3',
          question: '小明有25個盒子，每個盒子有8個蘋果，一共有多少個蘋果？',
          answer: '200個',
          solution: '25 × 8 = 200\n25個盒子，每個盒子8個蘋果，所以一共有200個蘋果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n3-q4',
          question: '計算：234 × 6 = ?',
          answer: '1404',
          solution: '234 × 6 = 1404\n個位：4 × 6 = 24，寫4進2\n十位：3 × 6 + 2 = 20，寫0進2\n百位：2 × 6 + 2 = 14',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n3-q5',
          question: '小華有18排椅子，每排有12張椅子，一共有多少張椅子？',
          answer: '216張',
          solution: '18 × 12 = 216\n18排椅子，每排12張，所以一共有216張椅子。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3n4',
      code: '3N4',
      title: '除法(二)',
      description: '學習多位數的除法運算',
      objectives: [
        '學會兩位數除以一位數',
        '學會三位數除以一位數',
        '理解除法的餘數概念',
        '解決除法應用題'
      ],
      sampleQuestions: [
        {
          id: 'p3-3n4-q1',
          question: '計算：48 ÷ 6 = ?',
          answer: '8',
          solution: '48 ÷ 6 = 8\n可以用乘法驗證：6 × 8 = 48',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n4-q2',
          question: '計算：156 ÷ 4 = ?',
          answer: '39',
          solution: '156 ÷ 4 = 39\n可以用乘法驗證：4 × 39 = 156',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n4-q3',
          question: '小明有96個蘋果，要分給8個小朋友，每人分到多少個？',
          answer: '12個',
          solution: '96 ÷ 8 = 12\n96個蘋果分給8個小朋友，每人分到12個蘋果。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n4-q4',
          question: '計算：234 ÷ 6 = ?',
          answer: '39',
          solution: '234 ÷ 6 = 39\n可以用乘法驗證：6 × 39 = 234',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n4-q5',
          question: '小華有156個糖果，要裝在12個盒子裡，每個盒子裝多少個？',
          answer: '13個',
          solution: '156 ÷ 12 = 13\n156個糖果裝在12個盒子裡，每個盒子裝13個糖果。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3n5',
      code: '3N5',
      title: '分數(一)',
      description: '認識分數的基本概念',
      objectives: [
        '認識分數的概念',
        '學會讀寫簡單分數',
        '理解分子和分母',
        '學會簡單分數的比較'
      ],
      sampleQuestions: [
        {
          id: 'p3-3n5-q1',
          question: '寫出分數：三分之一',
          answer: '1/3',
          solution: '三分之一用分數表示是1/3\n1是分子，3是分母。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n5-q2',
          question: '讀出分數：2/5',
          answer: '五分之二',
          solution: '2/5讀作五分之二\n2是分子，5是分母。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3n5-q3',
          question: '比較大小：1/3 和 1/4',
          answer: '1/3 > 1/4',
          solution: '分子相同時，分母越小，分數越大\n所以1/3 > 1/4',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n5-q4',
          question: '小明有8個蘋果，吃了3個，還剩下幾分之幾？',
          answer: '5/8',
          solution: '原本8個，吃了3個，還剩下5個\n所以還剩下5/8',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3n5-q5',
          question: '小華有12個糖果，給了小明4個，給了小紅3個，還剩下幾分之幾？',
          answer: '5/12',
          solution: '原本12個，給了4+3=7個，還剩下5個\n所以還剩下5/12',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3m1',
      code: '3M1',
      title: '長度和距離(四)',
      description: '進一步學習長度概念和測量',
      objectives: [
        '學會用千米(km)測量',
        '理解長度的單位換算',
        '學會長度的估算',
        '解決長度相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p3-3m1-q1',
          question: '1千米等於多少米？',
          answer: '1000米',
          solution: '1千米 = 1000米\n這是長度的基本換算關係。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3m1-q2',
          question: '2千米500米等於多少米？',
          answer: '2500米',
          solution: '2千米500米 = 2 × 1000 + 500 = 2000 + 500 = 2500米',
          difficulty: 'basic'
        },
        {
          id: 'p3-3m1-q3',
          question: '小明家到學校有1千米200米，小華家到學校有1千米500米，誰家離學校比較遠？',
          answer: '小華家',
          solution: '1千米200米 = 1200米\n1千米500米 = 1500米\n1500 > 1200，所以小華家離學校比較遠。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3m1-q4',
          question: '一條路長3千米800米，修了1千米500米，還剩下多少？',
          answer: '2千米300米',
          solution: '3千米800米 - 1千米500米 = 2千米300米\n3千米800米 = 3800米\n1千米500米 = 1500米\n3800 - 1500 = 2300米 = 2千米300米',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3m1-q5',
          question: '三條路分別長2千米300米、2千米800米和3千米200米，最長的和最短的相差多少？',
          answer: '900米',
          solution: '最長：3千米200米 = 3200米\n最短：2千米300米 = 2300米\n3200 - 2300 = 900米',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3m2',
      code: '3M2',
      title: '重量',
      description: '認識重量的概念和測量',
      objectives: [
        '認識重量的概念',
        '學會用千克(kg)和克(g)測量',
        '理解重量的單位換算',
        '解決重量相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p3-3m2-q1',
          question: '1千克等於多少克？',
          answer: '1000克',
          solution: '1千克 = 1000克\n這是重量的基本換算關係。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3m2-q2',
          question: '2千克500克等於多少克？',
          answer: '2500克',
          solution: '2千克500克 = 2 × 1000 + 500 = 2000 + 500 = 2500克',
          difficulty: 'basic'
        },
        {
          id: 'p3-3m2-q3',
          question: '小明體重35千克，小華體重38千克，誰比較重？',
          answer: '小華',
          solution: '38 > 35，所以小華比較重。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3m2-q4',
          question: '一袋米重25千克，用掉8千克，還剩下多少？',
          answer: '17千克',
          solution: '25 - 8 = 17\n原本25千克，用掉8千克，所以還剩下17千克。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3m2-q5',
          question: '三袋米分別重20千克、25千克和30千克，最重的和最輕的相差多少？',
          answer: '10千克',
          solution: '最重：30千克，最輕：20千克\n30 - 20 = 10千克',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3m3',
      code: '3M3',
      title: '容量',
      description: '認識容量的概念和測量',
      objectives: [
        '認識容量的概念',
        '學會用升(L)和毫升(ml)測量',
        '理解容量的單位換算',
        '解決容量相關的應用題'
      ],
      sampleQuestions: [
        {
          id: 'p3-3m3-q1',
          question: '1升等於多少毫升？',
          answer: '1000毫升',
          solution: '1升 = 1000毫升\n這是容量的基本換算關係。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3m3-q2',
          question: '2升500毫升等於多少毫升？',
          answer: '2500毫升',
          solution: '2升500毫升 = 2 × 1000 + 500 = 2000 + 500 = 2500毫升',
          difficulty: 'basic'
        },
        {
          id: 'p3-3m3-q3',
          question: '小明有1升500毫升的水，小華有1升800毫升的水，誰的水比較多？',
          answer: '小華',
          solution: '1升500毫升 = 1500毫升\n1升800毫升 = 1800毫升\n1800 > 1500，所以小華的水比較多。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3m3-q4',
          question: '一瓶水有2升，喝了500毫升，還剩下多少？',
          answer: '1升500毫升',
          solution: '2升 - 500毫升 = 1升500毫升\n2升 = 2000毫升\n2000 - 500 = 1500毫升 = 1升500毫升',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3m3-q5',
          question: '三個瓶子分別有1升200毫升、1升500毫升和2升的水，最多的和最少的相差多少？',
          answer: '800毫升',
          solution: '最多：2升 = 2000毫升\n最少：1升200毫升 = 1200毫升\n2000 - 1200 = 800毫升',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3s1',
      code: '3S1',
      title: '三角形',
      description: '認識三角形的基本概念',
      objectives: [
        '認識三角形的概念',
        '學會識別不同種類的三角形',
        '理解三角形的基本性質',
        '學會三角形的分類'
      ],
      sampleQuestions: [
        {
          id: 'p3-3s1-q1',
          question: '三角形有多少條邊？',
          answer: '3條邊',
          solution: '三角形有3條邊，3個角，內角和是180度。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3s1-q2',
          question: '等邊三角形的三條邊有什麼特點？',
          answer: '都相等',
          solution: '等邊三角形的三條邊都相等，三個角都是60度。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3s1-q3',
          question: '等腰三角形的兩條邊有什麼特點？',
          answer: '相等',
          solution: '等腰三角形有兩條邊相等，兩個角相等。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3s1-q4',
          question: '直角三角形有一個角是多少度？',
          answer: '90度',
          solution: '直角三角形有一個角是90度，叫做直角。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3s1-q5',
          question: '等邊三角形和等腰三角形有什麼不同？',
          answer: '邊的數量不同',
          solution: '等邊三角形的三條邊都相等，等腰三角形只有兩條邊相等。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3s2',
      code: '3S2',
      title: '圓形',
      description: '認識圓形的基本概念',
      objectives: [
        '認識圓形的概念',
        '學會識別圓形的特徵',
        '理解圓形的基本性質',
        '學會圓形的測量'
      ],
      sampleQuestions: [
        {
          id: 'p3-3s2-q1',
          question: '圓形有沒有角？',
          answer: '沒有角',
          solution: '圓形沒有角，是一條封閉的曲線。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3s2-q2',
          question: '圓形的中心到邊緣的距離叫什麼？',
          answer: '半徑',
          solution: '圓形的中心到邊緣的距離叫做半徑。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3s2-q3',
          question: '圓形的直徑是半徑的幾倍？',
          answer: '2倍',
          solution: '圓形的直徑是半徑的2倍。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3s2-q4',
          question: '圓形的周長和直徑有什麼關係？',
          answer: '周長約等於直徑的3.14倍',
          solution: '圓形的周長約等於直徑的3.14倍，這個數叫做圓周率。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3s2-q5',
          question: '圓形和正方形有什麼不同？',
          answer: '邊的形狀不同',
          solution: '圓形沒有直線邊，正方形有4條直線邊。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3s3',
      code: '3S3',
      title: '四邊形(二)',
      description: '進一步認識四邊形',
      objectives: [
        '認識更多種類的四邊形',
        '學會比較四邊形的特徵',
        '理解四邊形的基本性質',
        '學會四邊形的分類'
      ],
      sampleQuestions: [
        {
          id: 'p3-3s3-q1',
          question: '平行四邊形的對邊有什麼特點？',
          answer: '平行且相等',
          solution: '平行四邊形的對邊平行且相等。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3s3-q2',
          question: '菱形的四條邊有什麼特點？',
          answer: '都相等',
          solution: '菱形的四條邊都相等，對角線互相垂直。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3s3-q3',
          question: '梯形有幾組平行邊？',
          answer: '1組',
          solution: '梯形有1組平行邊，叫做上底和下底。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3s3-q4',
          question: '正方形和菱形有什麼相同點？',
          answer: '四條邊都相等',
          solution: '正方形和菱形的四條邊都相等。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3s3-q5',
          question: '長方形和正方形有什麼不同？',
          answer: '邊長不同',
          solution: '正方形的四條邊都相等，長方形的邊長不一定相等。',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3d1',
      code: '3D1',
      title: '棒形圖',
      description: '認識棒形圖的基本概念',
      objectives: [
        '認識棒形圖的概念',
        '學會讀取棒形圖的數據',
        '理解棒形圖的用途',
        '學會簡單的數據分析'
      ],
      sampleQuestions: [
        {
          id: 'p3-3d1-q1',
          question: '棒形圖中，棒的高度代表什麼？',
          answer: '數量',
          solution: '棒形圖中，棒的高度代表數量的大小。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3d1-q2',
          question: '如果棒形圖顯示小明有15個蘋果，小華有20個蘋果，誰的蘋果比較多？',
          answer: '小華',
          solution: '20 > 15，所以小華的蘋果比較多。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3d1-q3',
          question: '三個班級分別有25、30、35個學生，用棒形圖表示，哪個班級最高？',
          answer: '第三班',
          solution: '35 > 30 > 25，所以第三班的棒最高。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3d1-q4',
          question: '四個同學分別有10、15、12、18個糖果，用棒形圖表示，哪個同學的棒最高？',
          answer: '第四個同學',
          solution: '18 > 15 > 12 > 10，所以第四個同學的棒最高。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3d1-q5',
          question: '五個班級分別有20、25、30、35、40個學生，用棒形圖表示，最高的和最矮的相差多少？',
          answer: '20個',
          solution: '最高：40個，最矮：20個\n40 - 20 = 20個',
          difficulty: 'advanced'
        }
      ]
    },
    {
      id: 'p3-3f1',
      code: '3F1',
      title: '探索與研究',
      description: '通過活動發現數學規律',
      objectives: [
        '培養數學思維能力',
        '學會觀察和發現規律',
        '提高解決問題的能力',
        '培養探索精神'
      ],
      sampleQuestions: [
        {
          id: 'p3-3f1-q1',
          question: '觀察數字：4, 8, 12, 16, 20，下一個數字是什麼？',
          answer: '24',
          solution: '每個數字都比前一個多4，所以下一個是20 + 4 = 24。',
          difficulty: 'basic'
        },
        {
          id: 'p3-3f1-q2',
          question: '用9個相同的正方形可以拼成什麼圖形？',
          answer: '正方形',
          solution: '9個正方形可以拼成一個大正方形，3×3的排列。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3f1-q3',
          question: '小明有12個蘋果，每次吃3個，可以吃幾天？',
          answer: '4天',
          solution: '12 ÷ 3 = 4\n12個蘋果，每天吃3個，可以吃4天。',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3f1-q4',
          question: '找出規律：1, 3, 6, 10, ?',
          answer: '15',
          solution: '每個數字都是前一個加上位置數：1+2=3, 3+3=6, 6+4=10, 10+5=15',
          difficulty: 'intermediate'
        },
        {
          id: 'p3-3f1-q5',
          question: '用8根相同長度的木棒可以拼成什麼圖形？',
          answer: '正八邊形',
          solution: '8根相同長度的木棒可以拼成正八邊形。',
          difficulty: 'advanced'
        }
      ]
    }
  ]
}; 